import { ArrowRight, CircleCheck, WifiOff } from 'lucide-react'
import { useState, type FormEvent } from 'react'
import { Navigate } from 'react-router-dom'
import { Brand } from '../components/Brand'
import { WaveArtwork } from '../components/WaveArtwork'
import { useApp } from '../state/AppContext'

export function AuthPage() {
  const { user, backendAvailable, login, register, enterDemo, busy, error } = useApp()
  const [create, setCreate] = useState(false)
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  if (user) return <Navigate to={user.onboardingComplete ? '/hoje' : '/boas-vindas'} replace />

  const submit = async (event: FormEvent) => {
    event.preventDefault()
    try { if (create) await register(name, email, password); else await login(email, password) } catch { /* exibido pelo contexto */ }
  }

  return <main className="auth-page">
    <section className="auth-hero">
      <Brand light />
      <div className="auth-copy"><p className="kicker">Escuta clássica, sem prova.</p><h1>Uma obra.<br />Uma semana.<br /><em>Outro ouvido.</em></h1><p>Você escuta primeiro. A explicação chega depois — no tempo certo.</p></div>
      <WaveArtwork />
      <div className="auth-proof"><CircleCheck /><span>Sem jargão obrigatório</span><CircleCheck /><span>No seu ritmo</span></div>
    </section>
    <section className="auth-panel">
      <div className="auth-panel__inner">
        <p className="step-label">{create ? 'Crie seu acesso' : 'Bom ter você aqui'}</p>
        <h2>{create ? 'Comece pelo primeiro encontro.' : 'Continue sua escuta.'}</h2>
        <form onSubmit={submit}>
          {create && <label>Como podemos chamar você?<input value={name} onChange={(e) => setName(e.target.value)} placeholder="Seu nome" required /></label>}
          <label>E-mail<input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="voce@email.com" required /></label>
          <label>Senha<input type="password" minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="No mínimo 8 caracteres" required /></label>
          {error && <p className="form-error">{error}</p>}
          <button className="button button--primary" disabled={busy || !backendAvailable}>{busy ? 'Só um instante…' : <>{create ? 'Criar conta' : 'Entrar'}<ArrowRight /></>}</button>
        </form>
        <button className="text-button" onClick={() => setCreate((value) => !value)}>{create ? 'Já tenho uma conta' : 'Quero criar minha conta'}</button>
        <div className="demo-divider"><span>ou conheça agora</span></div>
        <button className="button button--outline" onClick={enterDemo}>Experimentar ciclo-piloto <ArrowRight /></button>
        {!backendAvailable && <p className="backend-note"><WifiOff /> Sem conexão no momento — a demonstração continua disponível.</p>}
      </div>
    </section>
  </main>
}
